"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.borderWidthTokens = void 0;
const GlobalDesignToken_1 = require("../../types/GlobalDesignToken");
const borderWidthNone = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'borderWidth-none',
    fallback: '0px'
});
const borderWidthS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'borderWidth-s',
    fallback: '1px'
});
const borderWidthM = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'borderWidth-m',
    fallback: '2px'
});
exports.borderWidthTokens = {
    borderWidthS,
    borderWidthM,
    borderWidthNone
};
//# sourceMappingURL=BorderWidth.js.map